import { MSG } from "@eldrun/protocol";
import type { SlotRef } from "@eldrun/sim";
import type { MatchRoomHandle } from "./match-client.ts";

/** Intenções de inventário (o servidor valida e aplica; a UI só reflete o estado). */
export class InventoryActions {
  private readonly room: MatchRoomHandle;

  constructor(room: MatchRoomHandle) {
    this.room = room;
  }

  move(from: SlotRef, to: SlotRef, qty?: number): void {
    this.room.send(MSG.invMove, qty === undefined ? { from, to } : { from, to, qty });
  }

  split(slot: SlotRef): void {
    this.room.send(MSG.invSplit, { slot });
  }

  quick(slot: SlotRef): void {
    this.room.send(MSG.invQuick, { slot });
  }

  gather(itemId: string): void {
    this.room.send(MSG.invGather, { itemId });
  }

  discard(slot: SlotRef, qty?: number): void {
    this.room.send(MSG.invDiscard, qty === undefined ? { slot } : { slot, qty });
  }

  select(index: number): void {
    this.room.send(MSG.invSelect, { index });
  }

  craft(recipeId: string, times: number): void {
    this.room.send(MSG.craft, { recipeId, times });
  }

  place(slot: number, x: number, z: number, yaw: number): void {
    this.room.send(MSG.place, { slot, x, z, yaw });
  }
}
